import React, { useState } from "react";

import css from "./carousel_base.module.scss";

type CarouselItem = {
  id: string | number;
  content: JSX.Element;
};

export type CarouselBaseProps = {
  items: CarouselItem[];
  activeIndex: number;
  visibleItems?: number;
};

// CarouselBase is meant for items with equal width
export const CarouselBase = ({ items, activeIndex, visibleItems = 1 }: CarouselBaseProps): JSX.Element => {
  const [carouselRef, setCarouselRef] = useState<HTMLDivElement | null>(null);
  const [firstItemRef, setFirstItemRef] = useState<HTMLDivElement | null>(null);

  const itemWidth = firstItemRef?.clientWidth || 0;
  const carouselHeight = carouselRef?.clientHeight || 0;
  const offset = activeIndex * itemWidth * -1;

  return (
    <div className={css.wrapper} style={{ width: visibleItems * itemWidth, height: carouselHeight }}>
      <div
        ref={(ref) => setCarouselRef(ref)}
        className={css.carousel}
        style={{
          transform: `translate(${offset}px, 0)`
        }}
      >
        {items.map(({ id, content }, index) => (
          <div ref={index === 0 ? (ref) => setFirstItemRef(ref) : undefined} key={id}>
            {content}
          </div>
        ))}
      </div>
    </div>
  );
};
